import { render, staticRenderFns } from "./salaryGen.vue?vue&type=template&id=cf72a838&scoped=true"
import script from "./salaryGen.vue?vue&type=script&lang=js"
export * from "./salaryGen.vue?vue&type=script&lang=js"
import style0 from "./salaryGen.vue?vue&type=style&index=0&id=cf72a838&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf72a838",
  null
  
)

export default component.exports